const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

// Client CRUD
export const createClient = (body) => request('/clients', { method: 'POST', body: JSON.stringify(body) });
export const getClientList = (params = {}) => {
  const query = new URLSearchParams();
  if (params.rmUserId) query.append('rmUserId', params.rmUserId);
  if (params.plannerId) query.append('plannerId', params.plannerId);
  if (params.segment) query.append('segment', params.segment);
  const queryString = query.toString();
  return request(`/clients${queryString ? '?' + queryString : ''}`);
};
export const getClientDetail = (id) => request(`/clients/${id}`);

// Checklist
export const toggleChecklistItem = (clientId, stageUid, itemUid, userId) =>
  request(`/clients/${clientId}/checklist/${stageUid}/${itemUid}/toggle`, {
    method: 'PUT',
    body: JSON.stringify({ userId })
  });

export const approveChecklistItem = (clientId, stageUid, itemUid, userId) =>
  request(`/clients/${clientId}/checklist/${stageUid}/${itemUid}/approve`, {
    method: 'POST',
    body: JSON.stringify({ userId })
  });

export const rejectChecklistItem = (clientId, stageUid, itemUid, userId, rejectionNote) =>
  request(`/clients/${clientId}/checklist/${stageUid}/${itemUid}/reject`, {
    method: 'POST',
    body: JSON.stringify({ userId, rejectionNote })
  });

// Stage workflow
export const submitStageForReview = (clientId, stageUid, userId) =>
  request(`/clients/${clientId}/stages/${stageUid}/submit-complete`, {
    method: 'POST',
    body: JSON.stringify({ userId })
  });

export const approveStage = (clientId, stageUid, userId, comment) =>
  request(`/clients/${clientId}/stages/${stageUid}/approve`, {
    method: 'POST',
    body: JSON.stringify({ userId, comment })
  });

export const rejectStage = (clientId, stageUid, userId, comment) =>
  request(`/clients/${clientId}/stages/${stageUid}/reject`, {
    method: 'POST',
    body: JSON.stringify({ userId, comment })
  });

// Notes
export const addNote = (clientId, noteType, rawText, authorUserId) =>
  request(`/clients/${clientId}/notes`, {
    method: 'POST',
    body: JSON.stringify({ noteType, rawText, authorUserId })
  });

export const getNotes = (clientId) => request(`/clients/${clientId}/notes`);

// Assignment
export const assignClient = (clientId, body) =>
  request(`/clients/${clientId}/assign`, { method: 'PUT', body: JSON.stringify(body) });
